import React, { useState, useEffect } from "react";
import config from "../../Config";
import axios from "axios";

function RouteSectionDropDown(props) {
  const [AccessKey, setAccessKey] = useState(localStorage.getItem("AccessKey"));
  const [UserID, setUserID] = useState(localStorage.getItem("ID"));
  const [MemberType, setMemberType] = useState(
    localStorage.getItem("MemberType")
  );
  const [Busrouts, setBusrouts] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);


    const apiData = {
      AccessKey: AccessKey,
      UserID: UserID,
      MemberType: MemberType,
      PageNo: 1,
      PageSize: 100,
      Root_Code: "",
      Area_Name: "",
      BusNumber: "",
    };

    var api_config = {
      method: "post",
      url: config.base_url + "Routesection/GetRouteSections",
      headers: {
        "Content-Type": "application/json",
      },
      data: apiData,
    };

    axios(api_config)
      .then(function (response) {
        ////console.log(response.data);
        setBusrouts(response.data.ListofRecords || []);
        setLoading(false);
      })
      .catch(function (error) {
        //console.log(error);
      });
  }, [props.RouteID]);

  if (loading) {
    return <option selected disabled>Loading...</option>
  } else {

    return Busrouts.map((item, index) => {
      return (
        <option
          value={item.ID}
          key={index}
          selected={item.ID == props.selectedRoot_ID}
        >
          {item.Route_Section_Name}
        </option>
      );
    });
  }
}

export default RouteSectionDropDown;